import React from 'react';

const money = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

const fechaHora = (value) => {
  if (!value) return '—';

  return new Intl.DateTimeFormat('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
};

export default function RestauranteHistorialTable({
  cuentas,
  cargando,
  onDetalle,
}) {
  if (cargando) {
    return (
      <div className="rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 p-8 text-center text-blanco-puro/70 shadow-xl backdrop-blur">
        Cargando historial...
      </div>
    );
  }

  if (!cuentas.length) {
    return (
      <div className="rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 p-8 text-center shadow-xl backdrop-blur">
        <div className="text-sm font-bold text-blanco-puro">
          No hay cuentas cerradas para mostrar
        </div>

        <div className="mt-1 text-xs text-blanco-puro/60">
          Probá modificando los filtros.
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 shadow-xl backdrop-blur">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1050px]">
          <thead className="bg-azul-oscuro/80">
            <tr className="text-left text-xs uppercase tracking-wide text-blanco-puro/60">
              <th className="px-4 py-4">Cuenta</th>
              <th className="px-4 py-4">Fecha</th>
              <th className="px-4 py-4">Mesa</th>
              <th className="px-4 py-4 text-center">
                Comensales
              </th>
              <th className="px-4 py-4">Cobró</th>
              <th className="px-4 py-4">Medio</th>
              <th className="px-4 py-4 text-center">
                Productos
              </th>
              <th className="px-4 py-4 text-right">Total</th>
              <th className="px-4 py-4 text-right">Acción</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-blanco-puro/10">
            {cuentas.map((cuenta) => {
              const pagos = cuenta.pagos || [];
              const pedidos = cuenta.pedidos || [];

              const operadores = [
                ...new Set(
                  pagos
                    .map((pago) => pago.usuario?.nombre)
                    .filter(Boolean)
                ),
              ];

              const medios = [
                ...new Set(
                  pagos
                    .map((pago) => pago.medioPago?.nombre)
                    .filter(Boolean)
                ),
              ];

              const productos = pedidos.reduce(
                (total, pedido) =>
                  total +
                  (pedido.items || []).reduce(
                    (subtotal, item) =>
                      subtotal + Number(item.cantidad || 0),
                    0
                  ),
                0
              );

              const totalFinal =
                Number(cuenta.total || 0) +
                Number(cuenta.propina_monto || 0);

              const mesa =
                cuenta.sesion?.mesa?.alias ||
                cuenta.sesion?.mesa?.nombre ||
                '—';

              return (
                <tr
                  key={cuenta.id}
                  className="transition hover:bg-blanco-puro/5"
                >
                  <td className="px-4 py-4 font-bold text-amarillo-dorado">
                    #{cuenta.id}
                  </td>

                  <td className="px-4 py-4 text-sm text-blanco-puro">
                    {fechaHora(cuenta.cerrada_at)}
                  </td>

                  <td className="px-4 py-4 text-sm font-semibold text-blanco-puro">
                    {mesa}
                  </td>

                  <td className="px-4 py-4 text-center text-sm text-blanco-puro">
                    {cuenta.sesion?.comensales ?? '—'}
                  </td>

                  <td className="px-4 py-4 text-sm text-blanco-puro">
                    {operadores.join(', ') || '—'}
                  </td>

                  <td className="px-4 py-4 text-sm text-blanco-puro">
                    {medios.join(' + ') || '—'}
                  </td>

                  <td className="px-4 py-4 text-center text-sm font-semibold text-blanco-puro">
                    {productos}
                  </td>

                  <td className="px-4 py-4 text-right text-base font-bold text-blanco-puro">
                    {money(totalFinal)}
                  </td>

                  <td className="px-4 py-4 text-right">
                    <button
                      type="button"
                      onClick={() => onDetalle(cuenta)}
                      className="rounded-lg border border-amarillo-dorado/50 px-3 py-1.5 text-xs font-bold text-amarillo-dorado transition hover:bg-amarillo-dorado hover:text-azul-oscuro"
                    >
                      Ver detalle
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
